import { render, staticRenderFns } from "./RoamingRatesCell.vue?vue&type=template&id=211a5820&scoped=true&"
import script from "./RoamingRatesCell.vue?vue&type=script&lang=js&"
export * from "./RoamingRatesCell.vue?vue&type=script&lang=js&"
import style0 from "./RoamingRatesCell.vue?vue&type=style&index=0&id=211a5820&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "211a5820",
  null
  
)

export default component.exports